<template>
    <div class="main">
        <Breadcrumb  class="bread" separator=">">
            <BreadcrumbItem to="/">
                <img class="bread-icon" src="../assets/images/icon-location.png"/>首页
            </BreadcrumbItem>
            <BreadcrumbItem to="/corporateKnowledge">公司见闻</BreadcrumbItem>
            <BreadcrumbItem class="bread-last">{{title}}</BreadcrumbItem>
        </Breadcrumb>
        <!-- <h4 class="cor-title">
            {{title}}
        </h4>     -->
        <div v-html="contents" class="contents"></div>
        <!-- <template v-for="(con,index) in contents" >
            <div class="text-center" v-if="con.img">
                <img class="cor-img"  :src="baseURL + con.img" alt="" :key="index">
            </div>
            <p class="cor-para" v-else :key="index">{{con.text}}</p>
        </template> -->
    </div>
</template>
<script>
import * as apis from "@/api/other"
import {baseURL} from '@/api/axios'
export default {
    data(){
        return {
            baseURL,
            id: 0,
            title: '',
            contents: ''
        }
    },
    mounted(){
        let id = this.$route.params.id;
        this.id = id;
        this.getKnowledgeInfos(id);
    },
    methods: {
        async getKnowledgeInfos(id){
            try{
                let data = {
                    id: id
                };
                let res = await apis.getCorperateKnowledgeDetail(data);
                if(res.code === 200){
                    this.contents = res.data.content;
                    this.title = res.data.title;
                }
            }catch(e){
                console.log(e)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.main{
    background: #fff;
    padding: 0 0 150px;
    overflow: hidden;
}
.cor-title{
    font-size: 48px;
    color: #333130;
    line-height: 54px;
    text-align: center;
    margin: 66px 0; 
}
.cor-img{
    width: auto;
    height: auto;
    margin-bottom: 40px;
}
.cor-para{
    font-size: 22px;
    color: #333130;
    line-height: 44px;
    text-indent: 44px;
    margin-bottom: 40px;
}
.bread{
    margin: 50px 50px 70px;
}
.contents{
    padding: 0 50px;
}
</style>